import { RefObject } from "react";
import { Button, ButtonProps, styled, Typography } from "@mui/material";
import { FilterAltOff } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { useUrlFilterTags } from "hooks/filterHooks";

interface Props extends ButtonProps {
  search: string;
  inputRef: RefObject<HTMLInputElement | undefined> | undefined;
}

export default function ResetFilterButton(props: Props) {
  const { search, inputRef, ...buttonProps } = props;
  const { t } = useTranslation();
  const { tagIds, resetTagFilters } = useUrlFilterTags();

  function onReset() {
    resetTagFilters();

    if (inputRef && inputRef.current) inputRef.current.value = "";
  }

  return (
    <StyledButton
      {...buttonProps}
      onClick={onReset}
      disabled={tagIds.length === 0 && !search}
    >
      <Typography color="inherit" variant="subtitle1" noWrap>
        <FilterAltOff />
        {t("label.resetFilters")}
      </Typography>
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  .MuiTypography-root {
    display: inline-flex;
    gap: ${({ theme }) => theme.spacing(1)};
  }
  .disabled {
    pointer-events: none;
    background-color: ${({ theme }) => theme.palette.background.paper};
  }
`;
